// The public place summary server.js embeds in Analysis pages
// (<script id="initial-place" type="application/json">, see
// server/renderAnalysis.js), so the logged-out preview card can render at
// once without fetching it again. Read once: later navigations fetch.
export function takeInitialPlace(slug, doc = document) {
    const el = doc.getElementById("initial-place")
    if (!el) return null
    el.remove()
    try {
        const place = JSON.parse(el.textContent)
        return place?.slug === slug ? place : null
    } catch {
        return null
    }
}
